import sidebarLocalStoreService from '@/services/api/local/sidebar'

export default {
	namespaced:true,
	modules:{
    sidebar: sidebarLocalStoreService
  }
}
